export const formatPhoneNumber = (phoneNumber) => {
  return `${phoneNumber.slice(0, 3)} ${phoneNumber.slice(
    3,
    8
  )} ${phoneNumber.slice(8)}`;
};
